// eslint-disable-next-line
export const defaultCurrency = {
  precision: 2,
  currency: { prefix: '' },
  distractionFree: { hideCurrencySymbol: true },
  valueAsInteger: true,
};
